import React, { useCallback } from 'react';
import classNames from 'classnames';
import artSrc from './connect-page-art-1.png';
import styles from './ConnectPageBanner.module.css';
import { useConnectPageHandlers } from '../../../../../../common/hooks/use-connect-page-handlers';
import { UIFilterCampaignKindType } from '../types';
import {
  ButtonColor,
  PrimaryButton,
} from '../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import { Banner } from '@mm/components';

type Props = {
  className?: string;
  kind: UIFilterCampaignKindType;
};

const map: Partial<
  Record<
    UIFilterCampaignKindType,
    { title: string; checkpoints: string[]; image: string }
  >
> = {
  ctm_ads: {
    title:
      'Connect your Facebook account in order integrate your chatbot with Click-to-Messenger ads:',
    checkpoints: [
      'Grow your Messenger contacts using CTM ads',
      'Use different chat dialogues for different ads',
      'Track which ads customers clicked through to start a conversation',
    ],
    image: artSrc,
  },
  sponsored_messages: {
    title:
      'Connect your Facebook account in order to create Sponsored Messages ads:',
    checkpoints: [
      'Re-engage your Messenger contacts with Sponsored Message ads',
      'Tailor your promotional messages to the right audiences',
      'See which Sponsored Messages generated new conversations',
    ],
    image: artSrc,
  },
};

export const ConnectPageBanner = ({ className, kind }: Props) => {
  const { connect } = useConnectPageHandlers();

  const onSubmitButtonClick = useCallback(connect, [connect]);

  const match = ['ctm_ads', 'sponsored_messages'].includes(kind);
  const content = map[kind];

  if (!match || !content) {
    return null;
  }

  const { title, checkpoints, image } = content;

  return (
    <Banner
      css={{
        container: classNames(className, styles.container),
        content: styles.content,
        left: styles.left,
        right: styles.right,
      }}
      title={title}
      checkpointsText={checkpoints}
      button={
        <PrimaryButton onClick={onSubmitButtonClick} color={ButtonColor.green}>
          Connect
        </PrimaryButton>
      }
    >
      <img src={image} className={styles.image} alt="Facebook" />
    </Banner>
  );
};
